export const annualPerks = [
  { label: 'Seasonal box with 6-8 products', info: '' },
  { label: 'Customize your entire box', info: 'Each season you can pick all products that go in your box.' },
  { label: 'Early access to Add-Ons / Edit Sales', info: '' },
  { label: 'Early access to Customize', info: '' },
  { label: 'Earlier shipping', info: '' },
  { label: 'Cancel anytime', info: '' },
];

export const seasonalPerks = [
  { label: 'Seasonal box with 6-8 products', info: '' },
  { label: '4 Customizations', info: 'Each season you can pick 4 of the products that go in your box.' },
  { label: 'Access to year-round sales', info: '' },
  { label: 'Cancel anytime', info: '' },
];
